import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Changement de catégorie ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("1"),
  /*#__PURE__*/_createElementVNode("sup", null, "ère"),
  /*#__PURE__*/_createTextVNode(" Catégorie")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", null, "ère", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("2"),
  /*#__PURE__*/_createElementVNode("sup", null, "ème"),
  /*#__PURE__*/_createTextVNode(" Catégorie")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("sup", null, "ème", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("3"),
  /*#__PURE__*/_createElementVNode("sup", null, "ème"),
  /*#__PURE__*/_createTextVNode(" Catégorie")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", null, "ème", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modifyCategorieParameters.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modifyCategorieParameters.visible) = $event)),
      closable: true,
      centered: true,
      "destroy-on-close": true,
      width: 500
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_row, { type: "flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "auto",
              align: "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "btn-warning",
                  onClick: _ctx.closeModifyCategorieModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  loading: _ctx.isUpdatingModifyCategorie,
                  onClick: _ctx.onUpdateCategories,
                  disabled: !_ctx.canUpdateCategories
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mettre à jour la catégorie ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_space, { direction: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { style: {"width":"120px"} }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.modifyCategorieParameters.categories.firstCategorieId,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modifyCategorieParameters.categories.firstCategorieId) = $event)),
                      style: {"width":"330px"},
                      "dropdown-match-select-width": true,
                      onSelect: _ctx.onFirstCategorieSelectionChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: null }, {
                          default: _withCtx(() => [
                            _createTextVNode("1"),
                            _hoisted_3,
                            _createTextVNode(" catégorie")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstCategories, (categorie) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: categorie.categorieId,
                            value: categorie.categorieId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "onSelect"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { style: {"width":"120px"} }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.modifyCategorieParameters.categories.secondCategorieId,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modifyCategorieParameters.categories.secondCategorieId) = $event)),
                      style: {"width":"330px"},
                      "dropdown-match-select-width": true,
                      onSelect: _ctx.onSecondCategorieSelectionChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: null }, {
                          default: _withCtx(() => [
                            _createTextVNode("2"),
                            _hoisted_5,
                            _createTextVNode(" catégorie")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondCategories, (categorie) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: categorie.categorieId,
                            value: categorie.categorieId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "onSelect"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.thirdCategories.length > 0)
              ? (_openBlock(), _createBlock(_component_a_row, {
                  key: 0,
                  type: "flex"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { style: {"width":"120px"} }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.modifyCategorieParameters.categories.thirdCategorieId,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modifyCategorieParameters.categories.thirdCategorieId) = $event)),
                          style: {"width":"330px"},
                          "dropdown-match-select-width": true,
                          onSelect: _ctx.onThirdCategorieSelectionChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: null }, {
                              default: _withCtx(() => [
                                _createTextVNode("3"),
                                _hoisted_7,
                                _createTextVNode(" catégorie")
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdCategories, (categorie) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: categorie.categorieId,
                                value: categorie.categorieId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(categorie.reference) + ". " + _toDisplayString(categorie.libelle), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "onSelect"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}